import * as React from 'react'
import CenteredViewLayout from '../components/CenteredViewLayout'

const title = 'Signed out'

const LoggedOut = (): JSX.Element => (
  <CenteredViewLayout title={title} subtitle="You're signed out." />
)

export default LoggedOut
